<script setup>
import { computed } from 'vue';
import Input from './Input.vue';
import {
  currencyInputToDecimal,
  formatCurrencyInput,
} from 'shared/helpers/talkviaInputMasks';

const props = defineProps({
  modelValue: { type: [String, Number], default: '' },
});
const emit = defineEmits(['update:modelValue']);
defineOptions({ inheritAttrs: false });
const formattedValue = computed(() => {
  const value = formatCurrencyInput(props.modelValue);
  return value ? `R$ ${value}` : '';
});
const updateValue = value =>
  emit('update:modelValue', currencyInputToDecimal(value));
const refreshMask = event => {
  const value = currencyInputToDecimal(event.target.value);
  event.target.value = value ? `R$ ${formatCurrencyInput(value)}` : '';
};
</script>

<template>
  <Input
    v-bind="$attrs"
    :model-value="formattedValue"
    type="text"
    inputmode="numeric"
    placeholder="R$ 0,00"
    @update:model-value="updateValue"
    @input="refreshMask"
  />
</template>
